@if (loadingFiles$ | async; as loadingFiles) {
  <div class="flex flex-col gap-4">
    @for (grouping of presentationalFiles; track grouping.label) {
      <div class="flex flex-col gap-4">
        <div class="flex justify-between items-center">
          <span
            class="expert-file-title"
            data-test-id="expert-files-grouping-title"
          >
            {{ grouping.label }}
          </span>

          <button
            type="button"
            class="replay-interview-link"
            data-test-id="expert-files-replay-interview-button"
            (click)="onReplayInterviewClick(grouping.groupId)"
          >
            Replay interview
          </button>
        </div>

        <ng-container
          [ngTemplateOutlet]="expertFiles"
          [ngTemplateOutletContext]="{
            files: grouping.files,
            loadingFiles: loadingFiles,
          }"
        ></ng-container>
      </div>
    }

    @if (uncategorisedFiles.length) {
      <div class="flex flex-col gap-4">
        @if (presentationalFiles.length) {
          <span
            class="expert-file-title"
            data-test-id="expert-files-grouping-title"
          >
            Other files
          </span>
        }

        <ng-container
          [ngTemplateOutlet]="expertFiles"
          [ngTemplateOutletContext]="{
            files: uncategorisedFiles,
            loadingFiles: loadingFiles,
          }"
        ></ng-container>
      </div>
    }
  </div>
}

<ng-template #expertFiles let-files="files" let-loadingFiles="loadingFiles">
  <div>
    @for (file of files; track file.fileKey) {
      <div class="file">
        @if (loadingFiles[file.fileKey]) {
          <div
            class="file-in-progress"
            data-test-id="expert-files-download-progress"
          >
            <span>{{ loadingFiles[file.fileKey].progress }}%</span>
            <mat-icon class="file-icon" (click)="cancelDownload(file.fileKey)">
              cancel
            </mat-icon>
          </div>
        }

        <div
          class="flex gap-2 justify-start items-center"
          data-test-id="expert-files-list-item"
          [class.dimmed]="loadingFiles[file.fileKey]"
          (click)="downloadFile(file)"
        >
          <mat-icon
            class="icon-color"
            data-test-id="expert-files-list-item-icon"
          >
            {{ file | fileDisplayIcon }}
          </mat-icon>

          <span
            class="flex grow"
            data-test-id="expert-files-list-item-file-name"
            [matTooltip]="file | fileDisplayName"
          >
            {{ file | fileDisplayName: 28 }}
          </span>

          <mat-icon class="icon-color">
            {{
              loadingFiles[file.fileKey]
                ? 'downloading'
                : downloadedFiles[file.fileKey]
                  ? 'download_done'
                  : 'download'
            }}
          </mat-icon>
        </div>
      </div>
    }
  </div>
</ng-template>
